import { render, staticRenderFns } from "./enclosure.vue?vue&type=template&id=63bb6be4&scoped=true&"
import script from "./enclosure.vue?vue&type=script&lang=js&"
export * from "./enclosure.vue?vue&type=script&lang=js&"
import style0 from "./enclosure.vue?vue&type=style&index=0&id=63bb6be4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb6be4",
  null
  
)

export default component.exports